import React from 'react';
import ExpandLess from '@material-ui/icons/ExpandLess';

export default function ExpandLessIcon() {

    return (
        <ExpandLess />
    );
}